<template>
  <div class="select" ref="select-custom" :class="{ order: this.ordenar}">
    <div class="select-container" :class="{'select-container-focused' : show, disabled: disabled}">
      <label class="form-label"><slot name="label-total" :events="{close}">{{ ordenar ? '' : label }}</slot></label>
      <div class="label-slot">
        <slot name="label"></slot>
      </div>
      <div @click="showForm()" class="d-flex">
        <icon-order class="icon-order" v-if="ordenar && showOrderIcon"/>
        <input
          class="form-select"
          style="width: 100% !important;"
          ref="search"
          type="text"
          :placeholder="place"
          :class="{'is-invalid': invalid, 'form-input' : true, blackPlaceholder: blackPlaceholder}"
          :value="isMobile && ordenar ? orderLabel : result"
          @input="isMobile && ordenar ? (orderLabel = $event) : (result = $event)"
          :readonly="true"
          @keyup.down="selectDown"
          @keyup.up="selectUp"
          @keyup.enter="select(selected)"
          @keypress="preventText"
          @keydown.delete="preventText"
          @keydown.stop="preventText"
          tabindex="-1"
          :disabled="disabled"
        >
      </div>
      <a href="#" @click.prevent="setValue('')" v-if="canClear && value">
      </a>
    </div>

    <div class="invalid-feedback" style="display: block" v-if="invalid">
      Campo Obrigatório
    </div>

    <div id="results" v-if="show">
      <div class="items d-flex flex-column justify-content-between" :class="{'display-top' : displayOnTop, 'display-right': displayOnRight}">
        <div class="search-container d-none d-lg-block" v-if="searchable">
          <input
            type="text"
            :placeholder="searchPlaceholder"
            @keyup.down="selectDown"
            @keyup.up="selectUp"
            @keyup.enter="select(selected)"
            @keydown.tab.prevent="preventTab"
            :value="search"
            @input="searchInput"
            class="search-input"
            v-focus
            tabindex="-1"
            :disabled="disabled"
          >
        </div>
        <div>
          <div
            class="d-flex flex-lg-row border-bottom shadow-sm nav-container d-block d-lg-none justify-content-between align-items-center ">
            <div class="title ms-3 d-flex justify-content-start align-items-center">
              <img src="/public/back.svg" width="18px" height="15px" class="me-3" @click="close"/>
              <div>{{ label }}</div>
            </div>
            <a href="#" class="text-primary font-size-default me-3" @click.prevent="reset" v-if="searchable && !async">Limpar</a>
          </div>

          <div v-if="searchable" class="selectContainer d-block d-lg-none p-3">
            <input
              type="text"
              :placeholder="searchPlaceholder"
              :value="search"
              @input="searchInput"
              class="search-input"
              style="width: 90%;"
              autocomplete="off"
              autocapitalize="off"
              autoCorrect="off"
              name="notASearchField"
              v-focus
              @keydown.tab.prevent="preventTab"
              tabindex="-1"
              :disabled="disabled"
            />
          </div>

          <div :class="{'selectContainer--item' : searchable, 'selectContainer--itemWithoutSearchable' : !searchable, 'ios' : isIOS, 'has-actions': hasActions}" class="pt-0">
            <div class="item"
                 :id="`item-${option[keyName]}`"
                 v-for="option in optionsFiltered"
                 :key="option[keyName]"
                 @click.prevent="!nested ? select(option) : ''"
                 :class="{selected: option[keyName] === selected[keyName], 'parent-item': nested && option.subtypes}"
                 v-if="optionsFiltered.length"
            >
              <slot name="item" v-bind:item="option">
                <div class="item-name">{{ option[valueName] }}</div>
              </slot>

              <div class="sub-items" v-if="nested">
                <div
                  class="sub-item"
                  v-for="subtype in option.subtypes"
                  :key="subtype[keyName]"
                  @click.prevent="select(subtype)"
                  :class="{selected: subtype[keyName] === selected[keyName]}"
                >
                  <div class="sub-item-name text-wrap">{{ subtype[valueName] }}</div>
                </div>
              </div>
            </div>

            <div v-if="!optionsFiltered.length" class="item">
              <slot name="no-data" :search="search" :events="{close}">
                <span class="no-data">Nenhum registro encontrado</span>
              </slot>
            </div>
          </div>
        </div>

        <slot name="actions" :events="{close}"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Integer from "vuelidate/lib/validators/integer";

export default {
  name: 'FormSelect',
  props: {
    value: {Type: String, default: ''},
    options: {type: Array, required: true},
    placeholder: {type: String, default: ''},
    searchPlaceholder: {type: String, default: ''},
    label: {type: String, default: ''},
    searchable: {type: Boolean, default: false},
    keyName: {type: String, default: 'item'},
    valueName: {type: String, default: 'name'},
    async: {Type: Boolean, default: false},
    invalid: {type: Boolean, default: false},
    canClear: {type: Boolean, default: true},
    showArrow: {type: Boolean, default: false},
    ordenar: {type: Boolean, default: false},
    disableScroll: {type: Boolean, default: true},
    blackPlaceholder: {type: Boolean, default: false},
    nested: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    isLocal: {type: Boolean, default: false},
    hasActions: {type: Boolean, default: false},
    showAllPlaceholder: {type: Boolean, default: false},
    twoWayOptions: {type: Boolean, default: true},
    showOrderIcon: {type: Boolean, default: true},
    orderLabel: {type: String, default: 'Ordenar'},
    displayOnRight: {type: Boolean, default: false},
    bottomOffset: {type: Integer, default: 270 }
  },
  data() {
    return {
      selected: {
        item: null
      },
      show: false,
      search: '',
      result: '',
      displayOnTop: false
    }
  },
  methods: {
    preventTab(event) {
      event.preventDefault();
    },
    close() {
      if(this.isIOS) {
        this.$root.$emit('clear-modal-header', false);
      }
      this.show = false;
      this.$emit('close');
    },
    reset() {
      if(this.disabled) {
        return
      }

      if (!this.async) {
        this.search = '';
      }
    },
    showForm() {
      if(this.disabled) {
        return;
      }

      this.$emit('click');
      this.search = '';

      this.displayOnTop = false;

      if (!this.show) {
        this.show = true;

        const element = this.$refs["select-custom"].getBoundingClientRect().top;
        if((window.innerHeight - element) < this.bottomOffset) {
          this.displayOnTop = true;
        }

      } else if (this.show) {
        this.close();
      }
    },
    preventText(evt) {
      evt.preventDefault();
    },
    selectDown() {
      let index = this.optionsFiltered.indexOf(this.selected);
      if (index === this.optionsFiltered.length - 1) {
        return false;
      }

      let container = this.searchable ? document.querySelector('.selectContainer--item') : document.querySelector('.selectContainer--itemWithoutSearchable');

      if(index >= 4 && container) {
        container.scrollTop = index * 33;
      }

      this.selected = this.optionsFiltered[index + 1];
    },
    selectUp() {
      let index = this.optionsFiltered.indexOf(this.selected);

      if (index <= 0) {
        return false;
      }

      let container = this.searchable ? document.querySelector('.selectContainer--item') : document.querySelector('.selectContainer--itemWithoutSearchable');

      if(index <= 5 && container) {
        container.scrollTop = 0;
      } else if(container) {
        container.scrollTop = index * 28;
      }


      this.selected = this.optionsFiltered[index - 1];
    },
    select(option) {

      if(this.selected !== option) {
        this.$emit('change', this.selected[this.keyName]);
      }

      this.selected = option;
      this.$emit('input', this.selected[this.keyName]);
      this.$emit('update', this.selected);
      if(this.selected.uf && this.isLocal) {
        this.result = this.selected.uf;
      } else {
        this.result = this.selected[this.valueName];
      }

      this.$nextTick(() => {
        const body = document.querySelector('body');
        const layout = document.querySelector('#more-filters');

        if (this.isIOS) {
          body.style.pointerEvents = 'none';
          if(layout) {
            layout.style.pointerEvents = 'none';
          }
        }

        this.close();

        if (this.isIOS) {
          setTimeout(() => {
            body.removeAttribute('style');
            if(layout) {
              layout.removeAttribute('style');
            }
          }, 100);
        }
      })
    },
    setValue(val) {
      if(this.disabled) {
        return
      }

      this.$emit('input', val);
      this.$emit('change', val);
    },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.close()
      }
    },
    syncValue() {
      if (this.value !== undefined) {
        if(!this.nested) {
          this.selected = this.options.find((option) => {
            return option[this.keyName] == this.value;
          });
        } else {
          this.selected = this.options.reduce(
            (prev, option) => prev || option.subtypes.find(item => item[this.keyName] === this.value),
            undefined
          );
        }


        if (this.selected) {
          if(this.selected.uf && this.isLocal) {
            this.result = this.selected.uf;
          } else {
            this.result = this.selected[this.valueName];
          }

          if (this.async) {
            this.$emit('addLocal', this.selected);
          }
        } else {
          this.selected = {
            [this.keyName]: ''
          }
          this.result = this.showAllPlaceholder ? 'Todos' : '';
        }

        //this.$emit('update', this.selected);
      }
    },
    searchInput(e) {
      if (this.async) {
        this.$emit('search', e.target.value);
      }

      this.search = e.target.value;
    },
    fixScroll() {
      this.$nextTick(() => {
        let element =  document.querySelector(`#item-${this.value}`);
        element.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'end' })
      })
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      }
    }
  },
  watch: {
    value() {
      this.syncValue();
    },
    show() {
      if (this.show) {
        if(this.isIOS) {
          this.$root.$emit('clear-modal-header', true);
        }
        document.addEventListener('mousedown', this.handleClickOutside);
        if(this.isIOS && this.isMobile && this.disableScroll) {
          this.$iosScroll.enable();
        }

        if(!this.disableScroll) {
          if(this.isIOS) {
            this.$iosScroll.enableOnModalFixed();
          }
        }
      } else {
        document.removeEventListener('mousedown', this.handleClickOutside);
        if(this.isIOS && this.isMobile && this.disableScroll) {
          this.$iosScroll.disable();
        }

        if(!this.disableScroll) {
          if(this.isIOS) {
            this.$iosScroll.disableOnModalFixed();
          }
        }
      }
    },
    options() {
      if(this.twoWayOptions) {
        this.syncValue()
      }
    }
  },
  mounted() {
    this.syncValue();
  },
  computed: {
    optionsFiltered() {
      if (this.searchable) {
        let options = this.options.filter((option) => {
          let searchOption = option[this.valueName].normalize('NFD').replace(/[\u0300-\u036f]/g, "");
          let searchString = this.search.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
          return searchOption.toLowerCase().includes(searchString.toLowerCase());
        });

        options = JSON.parse(JSON.stringify(options));

        const search = this.search;
        const query = new RegExp(search, 'i');
        options.forEach((o) => {
          this.$set(o, `${this.valueName}_highlighted`, o[this.valueName].replace(query, '<strong>$&</strong>'));
        });

        return options;
      }

      return this.options;
    },
    place() {
      if (!this.show) {
        return this.placeholder
      }
      return ''
    },
    isMobile() {
      return false
    },
    isIOS() {
      return false
    },
  }
}
</script>

<style lang="scss">

.search-container {
  border-bottom: 1px solid #ccc;
  padding: .5rem;
}

.order > .select-container {
  border: 1px solid var(--primary);

  @media (max-width: 768px) {
    padding: .15rem;
  }

  .icon-order {
    fill: var(--primary);
    margin: 5px 10px 0px 5px;

    @media (max-width: 768px) {
      height: 12px;
      width: 12px;
      margin: 5px 5px 0px 4px;
    }

  }

  .form-input {
    color: var(--primary) !important;

    @media (max-width: 768px) {
      margin-top: 0 !important;
      max-width: 62px;
    }
  }

  .arrow-down-light {
    margin-top: -2px;
    fill: var(--primary) !important;
  }
}

.search-input {
  margin-left: 11px;
  border: none;
  outline: none;
  color: #333;
  font-size: .9rem;
  width: 100%;
  padding-left: 33px;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' width='20px' height='20px' version='1.1' style='shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd'%0AviewBox='0 0 6773 6773' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cstyle type='text/css'%3E%3C!%5BCDATA%5B .fil0 %7Bfill:%23AAACAF%7D %5D%5D%3E%3C/style%3E%3C/defs%3E%3Cg id='Camada_x0020_1'%3E%3Cmetadata id='CorelCorpID_0Corel-Layer'/%3E%3Cpath class='fil0' d='M923 923c1030,-1030 2700,-1030 3730,0 963,963 1026,2484 189,3520l1732 1732c65,65 66,173 0,238l-161 161c-66,66 -174,65 -238,0l-1732 -1732c-1036,837 -2557,774 -3520,-189 -1030,-1030 -1030,-2700 0,-3730zm399 399c810,-810 2122,-810 2932,0 810,810 810,2122 0,2932 -810,810 -2122,810 -2932,0 -810,-810 -810,-2122 0,-2932z'/%3E%3C/g%3E%3C/svg%3E") no-repeat;
}


.form-input {
  width: 92% !important;
  color: var(--default-text-color) !important;

  &:focus {
    outline: none;
  }
}

.select {
  position: relative;

  &.local {
    .items {
      min-width: 300px;
    }
  }

  .items {
    @media (min-width: 992px) {
      min-width: max-content;
    }
  }

  &.ordenar {
    @media (max-width: 768px) {
      min-width: 74px;
      width: auto !important;
    }
  }
}

.select-container {
  &.select-container-focused {
    svg {
      transform: rotate(180deg);
    }
  }
}

#results {
  cursor: pointer;
  user-select: none;
  z-index: 99999;
}

.items {
  min-width: 150px;
  width: 100%;
  color: #333;
  border-radius: .32rem;
  position: absolute;
  margin-top: .6rem;
  background-color: #fff;
  left: 0;
  right: 0;
  z-index: 99999;
  padding-bottom: .2rem;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, .2);
  @media (min-width: 992px) {
    z-index: 99999;

    &.display-top {
      bottom: 55px !important;
      margin-bottom: .3rem;
    }

    &.display-right {
      right: 0;
      left: initial !important;
    }
  }
}

.selectContainer--item, .selectContainer--itemWithoutSearchable {
  overflow-y: scroll;
  max-height: 210px;
}

.item {
  color: #333;
  padding: .4rem;
  cursor: pointer;
  user-select: none;
  font-size: .9rem;

  &.selected {
    background: var(--background-business-type);
  }

  &:hover {
    background: var(--background-business-type);
  }

  &.parent-item {
    padding: 0;
    cursor: initial;

    .item-name {
      padding: .4rem;
      font-weight: 500;
      color: var(--primary);
    }

    &.selected {
      background: initial;
    }

    &:hover {
      background: initial;
    }
  }

  .sub-items {
    background: #fff;

    .sub-item {
      padding: .4rem;
      cursor: pointer;

      &.selected {
        background: var(--background-business-type) !important;
      }

      &:hover {
        background: var(--background-business-type) !important;
      }

      .sub-item-name {
        padding-left: .5rem;
      }
    }
  }
}

@media (max-width: 991px) {
  .nav-container {
    height: 55px;
  }

  .title {
    font-weight: 600;
  }

  #results {
    background: #fff;
  }

  .selectContainer {
    padding: .5rem;
  }

  .selectContainer--item {
    padding: .5rem;
    overflow-y: scroll;
    min-height: calc(100vh - 165px);

    &.has-actions {
      min-height: calc(100vh - 220px) !important;
    }
  }

  .selectContainer--itemWithoutSearchable {
    padding: .5rem;
    overflow-y: scroll;
    min-height: calc(100vh - 75px);
  }

  /*fix ios bottom bar space*/
  .selectContainer--item.ios {
    min-height: calc(100vh - 190px);
  }

  .selectContainer--itemWithoutSearchable.ios {
    min-height: calc(100vh - 135px);
  }

  .search--form_100 {
    position: relative;
  }

  .items {
    position: fixed;
    left: 0;
    width: 100vw;
    height: 100%;
    border: none;
    background-color: #fff;
    overflow: hidden;
    margin-top: 0;
    top: 0;
    bottom: 0;
  }

  .item {
    padding: .5rem .6rem;
  }

  .select-footer {
    padding: 1rem;
  }
}

.form-input.blackPlaceholder::placeholder {
  color: var(--default-text-color) !important;
  font-size: .85rem !important;
  font-weight: 500 !important;
  line-height: 1 !important;
  outline: none !important;
  text-shadow: none !important;

  @media (min-width: 820px) and (max-width: 991px) {
    font-size: .83rem !important;
  }

  @media (max-width: 400px) {
    font-size: .8rem !important;
  }

  @media (max-width: 359px) {
    font-size: .7rem !important;
  }
}

.no-data {
  color: #666;
}

.label-slot {
  position: absolute;
  top: 8px;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1;
  right: 8px;
}

</style>
